import { RootState } from "redux/rootReducer";

export const selectSubscribingSuperCity = (state: RootState) =>
  state.subscribeSuperCity.loading;
export const selectSubscribeSuperCityErrorMessage = (state: RootState) =>
  state.subscribeSuperCity.error;
export const subscribeSuperCityResponse = (state: RootState) =>
  state.subscribeSuperCity.subscribeSuperCityResponse;
